module.exports = __webpack_public_path__ + "static/img/bg-pt.e49de650.png";